




































import { Vue, Component } from 'vue-property-decorator'
import { WingBlank, MainHead } from '@/components/index'
import TitleInfo from './components/TitleInfo/index.vue'
import { GroupDetail, GroupDetailHistory, GroupDetailExport } from '@/api/GroupAdmin'
import { PaginationForm, GroupDetailHistoryForm } from '@/types/GroupAdmin'
import { ServerDownLoad } from '@/utils/downFile'
@Component({
  components: {
    WingBlank,
    MainHead,
    TitleInfo
  }
})
export default class GroupDetail1 extends Vue {
  // 头部数据
  headData: string[] = ['这里是分群的描述信息，对分群规则进行简单的介绍。']
  headTitle: string = '分群详情列表名称1'

  paginationObj:PaginationForm = {
    current: 0,
    size: 10,

  }
  /**
   * 详情头部信息
   * detailObj
   */
  detailObj = {}
  // 表格数据
  tableObj = []
  handleSizeChange(val: number) {
    this.paginationObj.size = val
    this.getDetailHistory()
  }
  handleCurrentChange(val: number) {
    this.paginationObj.current = val - 1
    this.getDetailHistory()
  }
  created() {
    this.getDetail()
    this.getDetailHistory()
  }
  async getDetail() {
    // return
    // eslint-disable-next-line no-unreachable
    const { id } = (this as any).$route.query
    const { data } = await GroupDetail(id)
    this.detailObj = data
  }
  async getDetailHistory() {
    const { id } = (this as any).$route.query
    const params: GroupDetailHistoryForm = {
      groupId: id,
      ...this.paginationObj
    }
    const { data } = await GroupDetailHistory(params)
    this.tableObj = data
  }
  // 点击下载
  async download(val: any) {
    const { id } = this.$route.query
    const params = {
      groupId: id,
      createTimeStr: val.createTime
    }
    ServerDownLoad(GroupDetailExport, params)
  }
}
